export const caba = 300;
export const leftProvinces = 600;
